// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as ApiUtils$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.bs.js";
import * as AdjustFareRepoConfig from "./AdjustFareRepoConfig.bs.js";

var adjustFareFareDetail = {
    "data": {
        "crn": "CRN000000000",
        "status": "completed",
        "start_time": 1682762000000,
        "trip_accepted_time": 1682761928000,
        "pickup_time": 1682762230000,
        "end_time": 1682764447000,
        "order_type": "spot",
        "has_fixed_strategy":true,
        "has_waypoints": false,
        "is_return_trip": null,
        "order_fare": {
            "travel_duration": 26.96,
            "travel_distance": 5.97,
            "waiting_time": 10.0,
            "total_restricted_time_mins": 0.0,
            "toll": 0.0,
            "road_tax": 0.0,
            "convenience_charge": 0.0,
            "environmental_tax": 0.0,
            "is_order_after_gst": true,
            "from_state": null,
            "to_state": null,
            "incidental_charges": [
              {
                "charge_type": {
                  "id": 3,
                  "name": "Police Fine",
                },
                amount: 15.0,
              },
              {
                "charge_type": {
                  "id": 1,
                  "name": "Parking Charge",
                },
                amount: 2.4,
              }
            ],
            "fare_without_previous_due": 320.55,
            "base_fare": 200.0,
            "waiting_charge": 0.0,
            "distance_charge": 39.7,
            "flat_surge": 0.0,
            "travel_duration_charge": 80.85,
            "total_taxes": 0.0,
            "travel_fare": 320.55,
            "subscription_discount": 0.0,
            "premium_discount": 0.0,
            "return_discount": 0.0,
            "referral_discount": 0.0,
            "coupon_discount": 0.0,
            "service_tax": 0.0,
            "swachh_bharat_tax": 0.0,
            "krishi_kalyan_tax": 0.0,
            "pod_charge": 0.0,
            "is_gst_effective": true,
            "is_inter_state": null,
            "is_gst_included_in_bill": true,
            "customer_gstin": null,
            "cgst": 0.0,
            "sgst": 0.0,
            "igst": 0.0,
            "vat": 0.0,
            "credit_charge": 0.0,
            "fare": 320.55,
            "cash_back": 0.0,
            "fare_after_cashback": 320.55,
            "tax_fares": []
        }
    }
};

var previewFareDetail = {
  "data": {
    "popup_message": null,
    "order_fare": {
      "travel_duration": 3.63,
      "travel_distance": 0,
      "waiting_time": 7,
      "total_restricted_time_mins": 0,
      "toll": 0,
      "road_tax": 0,
      "convenience_charge": 0,
      "environmental_tax": 0,
      "is_order_after_gst": true,
      "from_state": null,
      "to_state": null,
      "incidental_charges": [],
      "fare_without_previous_due": 35,
      "base_fare": 35,
      "waiting_charge": 0,
      "distance_charge": 0,
      "flat_surge": 0,
      "travel_duration_charge": 0,
      "total_taxes": 0,
      "travel_fare": 35,
      "subscription_discount": 0,
      "premium_discount": 0,
      "return_discount": 0,
      "referral_discount": 0,
      "coupon_discount": 0,
      "service_tax": 0,
      "swachh_bharat_tax": 0,
      "krishi_kalyan_tax": 0,
      "pod_charge": 0,
      "is_gst_effective": true,
      "is_inter_state": null,
      "is_gst_included_in_bill": true,
      "customer_gstin": null,
      "cgst": 0,
      "sgst": 0,
      "igst": 0,
      "vat": 0,
      "credit_charge": 0,
      "fare": 35,
      "cash_back": 0,
      "fare_after_cashback": 35,
      "tax_fares": []
    },
    "new_customer_fare_without_prev_dues": 35
  }
};

var updateSuccessfulResponse = {
        "title":"Success",
        "message":"update successful"
    };

var getIncidentalChargeTypesResponse = {
  "data": {
    "incidental_charge_types": [
      {
        "id": 1,
        "name": "Parking Charge"
      },
      {
        "id": 2,
        "name": "Gate Pass"
      },
      {
        "id": 3,
        "name": "Police Fine"
      },
      {
        "id": 4,
        "name": "Labour Charge"
      }
    ]
  }
};

function fetchFare(crn, fareType, _country) {
  return new Promise((function (resolve, param) {
                  return resolve({
                              TAG: /* Success */0,
                              _0: adjustFareFareDetail
                            });
                })).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(AdjustFareRepoConfig.AdjustFareResponseConverter.execute, result);
                        });
            });
}

function previewFareChanges(payload, _country) {
  return new Promise((function (resolve, param) {
                  return resolve({
                              TAG: /* Success */0,
                              _0: previewFareDetail
                            });
                })).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(AdjustFareRepoConfig.PreviewAdjustFareResponseConverter.execute, result);
                        });
            });
}

function updateFare(payload, _country) {
  return new Promise((function (resolve, param) {
                  return resolve({
                              TAG: /* Success */0,
                              _0: updateSuccessfulResponse
                            });
                })).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(AdjustFareRepoConfig.UpdateAdjustFareResponseConverter.execute, result);
                        });
            });
}

function getIncidentalChargeTypes(_country) {
  return new Promise((function (resolve, param) {
                  return resolve({
                              TAG: /* Success */0,
                              _0: getIncidentalChargeTypesResponse
                            });
                })).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(AdjustFareRepoConfig.IncidentalChargeTypeResponseConverter.execute, result);
                        });
            });
}

var AdjustFareRepo = {
  fetchFare: fetchFare,
  previewFareChanges: previewFareChanges,
  updateFare: updateFare,
  getIncidentalChargeTypes: getIncidentalChargeTypes
};

export {
  AdjustFareRepo ,
  
}
/* AdjustFareRepoConfig Not a pure module */
